<template>
    <div id="whatsapp-v2-channels">
        <AppBreadCrumb :paths="[{ title: $t('whatsappChannel.whatsappTitleV2') }]" :select="true"></AppBreadCrumb>
        <div style="background-color: #ffffff" class="d-flex right-page">
            <div class="ml-3 mt-3" style="flex: 0 0 100%">
                <div class="big-title">{{ $t("whatsappChannel.whatsappTitleV2") }}</div>
                <div class="channels">
                    <div
                        class="story channel-add"
                        @click="$feature.beforeCreateIntegrationChannel(createChannel, 'whatsapp-v2')"
                    >
                        <a-icon type="plus-circle" theme="filled" style="font-size: 30px" />
                        <span class="text-large font-weight-bolder mt-2" style="font-size: 20px; letter-spacing: 2px">
                            {{ $t("whatsappChannel.addChannel") }}
                        </span>
                    </div>
                    <div
                        class="channel-item"
                        :class="{ disabled: !isChannelAccessible(channel) }"
                        v-for="(channel, index) in channels"
                        @click="() => isChannelAccessible(channel) && editChannel(channel)"
                        :key="index"
                    >
                        <div class="icon-container">
                            <WhatsappIcon />
                        </div>
                        <div class="name-container">
                            <span class="name">{{ channel.name.toUpperCase() }}</span>
                            <span class="phone">
                                ({{ channel.payload.phoneNumber }}) - ({{ channel.forward.story }})
                            </span>
                        </div>

                        <div class="options">
                            <a-dropdown :trigger="['click']" placement="bottomRight">
                                <div class="icon-container ant-dropdown-link" @click="(e) => e.stopPropagation()">
                                    <span class="material-icons">more_horiz</span>
                                </div>
                                <template #overlay>
                                    <a-menu>
                                        <a-menu-item>
                                            <div
                                                class="icon-container"
                                                @click="
                                                    $router.push(
                                                        `/integrations/whatsapp-v2/${channel._id}/detail/integration`
                                                    )
                                                "
                                            >
                                                <md-icon style="margin-right: 10px">edit</md-icon>
                                                <span>{{ $t("message.edit") }}</span>
                                            </div>
                                        </a-menu-item>
                                        <a-menu-item
                                            @click="copyChannelId(channel._id)"
                                            style="display: flex; gap: 5px"
                                        >
                                            <i class="material-icons">content_copy</i>
                                            <span>Channel ID Kopyala</span>
                                        </a-menu-item>
                                        <a-menu-item>
                                            <div class="icon-container" @click="deleteMultiWp(channel._id)">
                                                <md-icon style="margin-right: 10px">delete</md-icon>
                                                <span>{{ $t("chatbotv2.delete") }}</span>
                                            </div>
                                        </a-menu-item>
                                    </a-menu>
                                </template>
                            </a-dropdown>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <WhatsappSolutionComparisonModal
            :visible="showInfoModal"
            @cancel="handleInfoCancel"
            @accept="handleInfoAccept"
        />

        <Modal2
            :title="$t('whatsappChannel.newWhatsappChannel')"
            :description="$t('whatsappChannel.newWhatsappChannelDescription')"
            class-name="new-waba"
            :showFooter="false"
            @cancel="showCreateForm = false"
            v-if="showCreateForm"
        >
            <NewW2Channel @cancel="showCreateForm = false" @ok="channelCreated" />
        </Modal2>
        <a-modal
            :visible="deleteModal"
            icon="exclamation-circle"
            :title="$t('whatsappChannel.whatsappChannel')"
            @cancel="deleteModal = false"
        >
            <p>{{ $t("whatsappChannel.deleteWhatsappChannelDescription") }}</p>
            <template #footer>
                <a-button key="back" @click="deleteModal = false">
                    {{ $t("chatbotv2.dismiss") }}
                </a-button>
                <a-button key="submit" type="danger" @click="deleteWhatsappChannel">
                    {{ $t("chatbotv2.delete") }}
                </a-button>
            </template>
        </a-modal>
    </div>
</template>

<script>
import WhatsappIcon from "../Chatbot/pages/integrations/svg/WhatsappIcon.vue";
import { mapActions, mapGetters, mapState } from "vuex";
import Modal2 from "../../../components/common/Modal2.vue";
import NewW2Channel from "./NewW2Channel.vue";
import AppBreadCrumb from "../../../components/common/AppBreadCrumb.vue";
import WhatsappSolutionComparisonModal from "../../../components/WhatsappSolutionComparisonModal.vue";
import _ from "lodash";
export default {
    name: "W2Channels",
    components: {
        NewW2Channel,
        WhatsappIcon,
        WhatsappSolutionComparisonModal,
        Modal2,
        AppBreadCrumb,
    },
    data() {
        return {
            showCreateForm: false,
            editShowCreateForm: false,
            updatingChannel: null,
            deleteModal: false,
            deleteChannelId: null,
            showInfoModal: false,
        };
    },
    computed: {
        ...mapState({
            channels: (state) => state.channel.channels.filter((x) => x.type === "whatsapp-v2"),
            features: (state) => state.site.features,
            isAdmin: (state) => state.auth.adminUser !== null,
            user: (state) => state.auth.user,
        }),
    },
    methods: {
        ...mapGetters({
            isChannelVisibleForMe: "channel/isChannelVisibleForMe",
        }),
        ...mapActions({
            listChannels: "channel/listChannels",
            listStories: "CB/listStories",
            deleteChannel: "channel/deleteChannel",
        }),
        copyChannelId(channelId) {
            navigator.clipboard
                .writeText(channelId)
                .then(() => {
                    this.$message.success("Channel ID kopyalandı");
                })
                .catch(() => {
                    this.$message.error("Channel ID kopyalanamadı");
                });
        },
        deleteMultiWp(channelId) {
            this.deleteModal = true;
            this.deleteChannelId = channelId;
        },
        createChannel() {
            this.showInfoModal = true;
        },
        editChannel(channel) {
            this.$router.push(`/integrations/whatsapp-v2/${channel._id}/detail/integration`);
        },
        channelCreated(channel) {
            this.showCreateForm = false;
            this.$router.push(`/integrations/whatsapp-v2/${channel._id}/detail/integration`);
        },
        deleteWhatsappChannel() {
            this.deleteChannel(this.deleteChannelId).then(() => {
                this.deleteModal = false;
            });
        },
        isChannelAccessible(channel) {
            return this.isAdmin || _.get(this.user, "isOwner", false) || this.isChannelVisibleForMe(channel);
        },
        handleInfoCancel() {
            this.showInfoModal = false;
        },
        handleInfoAccept() {
            this.showInfoModal = false;
            this.showCreateForm = true;
        },
    },
    mounted() {
        this.listChannels();
        this.listStories();
    },
    beforeDestroy() {},
};
</script>

<style lang="scss" scoped>
#whatsapp-v2-channels {
    width: 100%;
    min-height: calc(100vh - 50px);
    background: var(--color-bg-default);

    .channel-item.disabled {
        opacity: 0.5;
        pointer-events: none;
    }

    .big-title {
        font-weight: bold;
        font-size: 1.5rem;
        margin: 1rem 0;
    }

    .channels {
        display: flex;
        align-items: flex-start;
        padding-bottom: 1rem;
        flex-wrap: wrap;
        gap: 1rem;

        .story {
            background: #fff;
            border: 1px solid #a4a4a4;
            border-radius: 4px;
            padding: 1rem;
            cursor: pointer;
            transition: all 0.3s ease-in-out;
            width: 280px;
            height: 260px;
            min-width: 250px;
            max-width: 250px;
            margin-top: 10px;

            &:hover {
                border: 1px solid #06a9f3;
            }

            .title {
                margin: 1rem 0;
                font-weight: bold;
            }

            .chatbot-btn {
                border: none;
                background: #fff;
                border-radius: 4px;
                padding: 4px 8px;
                margin: 0;
                min-height: 34px;
                min-width: 34px;
                color: #000;
                display: flex;
                align-items: center;
                box-shadow: none !important;
                text-shadow: none !important;

                span {
                    text-align: left;
                }
            }
        }

        .channel-item {
            position: relative;
            background: #fff;
            border: 1px solid #a4a4a4;
            border-radius: 4px;
            padding: 1rem;
            cursor: pointer;
            transition: all 0.3s ease-in-out;
            width: 280px;
            height: 260px;
            min-width: 250px;
            max-width: 250px;
            text-align: center;
            transition: 500ms;
            margin-top: 10px;

            .web-hook-title {
                word-break: break-all;
            }

            &.disabled {
                opacity: 0.5;
            }

            &:hover {
                border: 1px solid #06a9f3;

                span {
                    color: #06a9f3;
                }

                transform: translateY(-10px);
                box-shadow: -4px 22px 11px -5px rgba(0, 0, 0, 0.1);

                .options {
                    .icon-container {
                        i {
                            transform: rotate(360deg);
                            color: #06a9f3;
                        }
                    }
                }
            }

            .icon-container {
                width: 70px;
                height: 70px;
                display: flex;
                margin: 0 auto;
                align-items: center;
                justify-content: center;
                border-radius: 6px;
                margin-top: 69px;
                overflow: hidden;
                position: relative;
                background: #58ca64;
                padding: 10px;
            }

            .name-container {
                display: flex;
                flex-direction: column;
                gap: 5px;
                font-size: 20px;
                font-weight: bold;
                margin-top: 10px !important;

                .phone {
                    font-size: 14px;
                    font-weight: normal;
                    color: #a4a4a4;
                }
            }

            span {
                margin: 1rem 0;
                margin-top: 10px !important;
                font-weight: bold;
                display: block;
                font-size: 20px;
                transition: 10ms;
            }

            .options {
                position: absolute;
                top: 5px;
                right: 5px;

                .icon-container {
                    background-color: transparent;
                    width: 25px;
                    height: 35px;
                    margin: 0;
                    padding: 0;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    padding: 3px;

                    i {
                        width: 100%;
                        height: 100%;
                        transition: 1s;
                    }
                }
            }
        }

        .channel-add {
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            background: #006cff;
            border-color: #006cff;
            color: #fff;

            i {
                margin: 0;
            }
        }
    }

    .w2-info-modal {
        ::v-deep .ant-modal-content {
            padding: 0;
            background: #ffffff;
            border-radius: 16px;
            box-shadow: 0 25px 80px rgba(0, 0, 0, 0.15);
            overflow: hidden;
        }

        .modal-wrapper {
            display: flex;
            flex-direction: column;
            height: 100%;
        }

        .modal-header {
            padding: 40px 40px 32px;
            border-bottom: 1px solid #f0f0f0;
            background: linear-gradient(135deg, #f5f7fa 0%, #ffffff 100%);
            border-radius: 16px 16px 0 0;

            .header-content {
                display: flex;
                align-items: center;
                gap: 18px;

                .header-icon {
                    width: 56px;
                    height: 56px;
                    background: linear-gradient(135deg, #1890ff 0%, #0a7a2a 100%);
                    border-radius: 14px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    flex-shrink: 0;
                    box-shadow: 0 8px 20px rgba(24, 144, 255, 0.25);

                    .material-icons {
                        color: #ffffff;
                        font-size: 32px;
                    }
                }

                .header-text {
                    .modal-title {
                        margin: 0;
                        font-size: 28px;
                        font-weight: 800;
                        color: #0a0a0a;
                        letter-spacing: -0.8px;
                    }

                    .modal-subtitle {
                        margin: 6px 0 0 0;
                        font-size: 14px;
                        color: #8c95a4;
                        font-weight: 500;
                    }
                }
            }
        }

        .modal-content {
            padding: 40px;
            max-height: 520px;
            overflow-y: auto;

            &::-webkit-scrollbar {
                width: 8px;
            }

            &::-webkit-scrollbar-track {
                background: transparent;
            }

            &::-webkit-scrollbar-thumb {
                background: #d9d9d9;
                border-radius: 4px;

                &:hover {
                    background: #bfbfbf;
                }
            }

            .intro-section {
                margin-bottom: 32px;

                p {
                    margin: 0;
                    font-size: 15px;
                    line-height: 1.7;
                    color: #4a5568;
                    font-weight: 500;
                }
            }

            .solutions-grid {
                display: grid;
                grid-template-columns: repeat(3, 1fr);
                gap: 20px;
                margin-bottom: 32px;

                @media (max-width: 1100px) {
                    grid-template-columns: 1fr;
                }

                .solution-card {
                    border: 2px solid #e8eef3;
                    border-radius: 14px;
                    overflow: hidden;
                    transition: all 0.35s cubic-bezier(0.34, 1.56, 0.64, 1);
                    background: #fafbfc;
                    display: flex;
                    flex-direction: column;
                    position: relative;

                    &::before {
                        content: '';
                        position: absolute;
                        top: 0;
                        left: 0;
                        right: 0;
                        height: 4px;
                        background: linear-gradient(90deg, #1890ff, #52c41a);
                        opacity: 0;
                        transition: opacity 0.35s ease;
                    }

                    &:hover {
                        border-color: #1890ff;
                        box-shadow: 0 16px 48px rgba(24, 144, 255, 0.16), 0 0 24px rgba(24, 144, 255, 0.08);
                        transform: translateY(-8px);

                        &::before {
                            opacity: 1;
                        }
                    }

                    .card-icon-wrapper {
                        padding: 24px;
                        background: linear-gradient(135deg, #fafbfc 0%, #f5f7fa 100%);
                        display: flex;
                        justify-content: center;
                        align-items: center;
                        min-height: 100px;

                        .solution-icon {
                            width: 60px;
                            height: 60px;
                            background: linear-gradient(135deg, #ff9c6e 0%, #ffc069 100%);
                            border-radius: 12px;
                            display: flex;
                            align-items: center;
                            justify-content: center;
                            color: #ffffff;
                            transition: all 0.35s ease;

                            svg {
                                width: 32px;
                                height: 32px;
                            }

                            &.v3-icon {
                                background: linear-gradient(135deg, #597ef7 0%, #85a5ff 100%);
                            }

                            &.waba-icon {
                                background: linear-gradient(135deg, #52c41a 0%, #95de64 100%);
                            }
                        }
                    }

                    &.solution-v2 {
                        .card-header {
                            background: linear-gradient(135deg, #fff7e6 0%, #fffbe6 100%);

                            .solution-badge.v2 {
                                background: linear-gradient(135deg, #fa8c16 0%, #ff7a45 100%);
                                color: #ffffff;
                                box-shadow: 0 4px 12px rgba(250, 140, 22, 0.3);
                            }
                        }

                        .check {
                            color: #52c41a;
                        }

                        .cross {
                            color: #ff7875;
                        }
                    }

                    &.solution-v3 {
                        .card-header {
                            background: linear-gradient(135deg, #e6f7ff 0%, #f0f5ff 100%);

                            .solution-badge.v3 {
                                background: linear-gradient(135deg, #1890ff 0%, #597ef7 100%);
                                color: #ffffff;
                                box-shadow: 0 4px 12px rgba(24, 144, 255, 0.3);
                            }
                        }

                        .check {
                            color: #52c41a;
                        }

                        .cross {
                            color: #ff7875;
                        }
                    }

                    &.solution-waba {
                        .card-header {
                            background: linear-gradient(135deg, #f6ffed 0%, #f9f9f9 100%);

                            .solution-badge.waba {
                                background: linear-gradient(135deg, #52c41a 0%, #95de64 100%);
                                color: #ffffff;
                                box-shadow: 0 4px 12px rgba(82, 196, 26, 0.3);
                            }
                        }

                        .check {
                            color: #52c41a;
                        }

                        .cross {
                            color: #ff7875;
                        }
                    }

                    .card-header {
                        padding: 20px;
                        position: relative;

                        .badge-wrapper {
                            display: flex;
                            align-items: center;
                            gap: 10px;
                            margin-bottom: 12px;

                            .solution-badge {
                                display: inline-block;
                                padding: 6px 14px;
                                border-radius: 8px;
                                font-size: 11px;
                                font-weight: 800;
                                letter-spacing: 1.2px;
                                text-transform: uppercase;
                            }

                            .solution-type {
                                font-size: 12px;
                                color: #8c95a4;
                                font-weight: 600;
                            }
                        }

                        h3 {
                            margin: 0 0 4px 0;
                            font-size: 18px;
                            font-weight: 800;
                            color: #0a0a0a;
                            letter-spacing: -0.3px;
                        }

                        .solution-subtitle {
                            margin: 0;
                            font-size: 13px;
                            color: #8c95a4;
                            font-weight: 600;
                        }
                    }

                    .card-body {
                        padding: 0 20px 20px 20px;
                        flex: 1;

                        .pros,
                        .cons {
                            &:not(:last-child) {
                                margin-bottom: 16px;
                            }

                            .section-label {
                                margin: 0 0 10px 0;
                                font-size: 12px;
                                font-weight: 800;
                                color: #0a0a0a;
                                text-transform: uppercase;
                                letter-spacing: 0.7px;
                                display: flex;
                                align-items: center;
                                gap: 6px;

                                &.cons-label {
                                    color: #ff7875;
                                }

                                .material-icons {
                                    font-size: 16px;
                                }
                            }

                            ul {
                                list-style: none;
                                padding: 0;
                                margin: 0;

                                li {
                                    font-size: 13px;
                                    line-height: 1.6;
                                    color: #595f69;
                                    margin-bottom: 8px;
                                    display: flex;
                                    align-items: flex-start;
                                    gap: 10px;

                                    .check,
                                    .cross {
                                        font-weight: 800;
                                        flex-shrink: 0;
                                        font-size: 15px;
                                        margin-top: 1px;
                                    }

                                    &:last-child {
                                        margin-bottom: 0;
                                    }
                                }
                            }
                        }
                    }
                }
            }

            .stability-alert {
                display: flex;
                gap: 16px;
                background: linear-gradient(135deg, #fff7e6 0%, #fffbe6 100%);
                border: 2px solid #ffc069;
                border-radius: 12px;
                padding: 20px;
                margin-bottom: 24px;

                .alert-icon {
                    flex-shrink: 0;
                    width: 44px;
                    height: 44px;
                    background: linear-gradient(135deg, #fa8c16 0%, #ff7a45 100%);
                    border-radius: 10px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    box-shadow: 0 6px 16px rgba(250, 140, 22, 0.25);

                    .material-icons {
                        color: #ffffff;
                        font-size: 24px;
                    }
                }

                .alert-content {
                    flex: 1;

                    .alert-title {
                        margin: 0 0 4px 0;
                        font-size: 14px;
                        font-weight: 800;
                        color: #c85a00;
                    }

                    .alert-text {
                        margin: 0;
                        font-size: 13px;
                        line-height: 1.65;
                        color: #7a5c3a;
                    }
                }
            }

            .info-footer {
                text-align: center;
                padding-top: 16px;
                border-top: 1px solid #f0f0f0;

                p {
                    margin: 0;
                    font-size: 13px;
                    color: #8c95a4;

                    a {
                        color: #1890ff;
                        font-weight: 700;
                        text-decoration: none;
                        transition: color 0.3s ease;

                        &:hover {
                            color: #0050b3;
                            text-decoration: underline;
                        }
                    }
                }
            }
        }

        .modal-footer {
            padding: 24px 40px 40px;
            display: flex;
            justify-content: flex-end;
            gap: 12px;
            background: #ffffff;
            border-top: 1px solid #f0f0f0;
            border-radius: 0 0 16px 16px;

            ::v-deep .ant-btn {
                min-width: 140px;
                height: 42px;
                font-weight: 700;
                border-radius: 8px;
                transition: all 0.35s cubic-bezier(0.34, 1.56, 0.64, 1);
                font-size: 14px;
                display: flex;
                align-items: center;
                justify-content: center;

                &.ant-btn-primary {
                    background: linear-gradient(135deg, #1890ff 0%, #0050b3 100%);
                    border: none;
                    box-shadow: 0 8px 20px rgba(24, 144, 255, 0.3);

                    &:hover,
                    &:focus {
                        background: linear-gradient(135deg, #0050b3 0%, #003a8c 100%);
                        box-shadow: 0 12px 28px rgba(24, 144, 255, 0.4);
                        transform: translateY(-2px);
                    }

                    &:active {
                        transform: translateY(0);
                    }
                }

                &:not(.ant-btn-primary) {
                    color: #1f2d3d;
                    border: 1.5px solid #d9d9d9;
                    background: #ffffff;

                    &:hover,
                    &:focus {
                        color: #1890ff;
                        border-color: #1890ff;
                        background: #f5f5f5;
                    }
                }
            }
        }
    }
}
</style>
